import React from "react";
import { Layout, Row, Col, Typography } from "antd";
import Header from "./components/Header";
import QuoteCard from "./components/QuoteCard";
import BreathingExercise from "./components/BreathingExercise";
import MeditationTimer from "./components/MeditationTimer";
import MusicPlayer from "./components/MusicPlayer";
import "./App.css";

const { Content, Footer } = Layout;
const { Text } = Typography;

const App: React.FC = () => {
  return (
    <Layout className="app-layout">
      <Header />
      <Content className="app-content">
        <Row gutter={[24, 24]}>
          <Col xs={24} lg={12}>
            <MusicPlayer />
          </Col>
          <Col xs={24} lg={12}>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <QuoteCard />
              </Col>
              <Col xs={24} sm={12}>
                <BreathingExercise />
              </Col>
              <Col xs={24} sm={12}>
                <MeditationTimer />
              </Col>
            </Row>
          </Col>
        </Row>
      </Content>
      <Footer className="app-footer">
        <Text className="app-footer-text">
          Góc Bình Yên &middot; hãy dành cho mình vài phút nghỉ ngơi mỗi ngày
        </Text>
      </Footer>
    </Layout>
  );
};

export default App;
